export default __webpack_public_path__ + "static/media/l_wdt_c_1.1491e281.mp3";